import axios from "axios";
import { get_access_token } from "./get_access_token"

export const createPassenger = async (user, passengerData) => {
  const access_token = await get_access_token(user);
  const apiUrl = process.env.REACT_APP_API_URL;

  let data = await axios({
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": access_token,
  },
    url: `${apiUrl}/api/profile/create_passenger`,
    params: {
      passenger: passengerData
    },
  });

  // name:                null,
  // surname:             null,
  // sex:                 null,
  // doc_type:            null,
  // doc_number:          null,
  // ExpirationDateMonth: null,
  // ExpirationDateYear:  null,
  // BirthDateDay:        null,
  // BirthDateMonth:      null,
  // BirthDateYear:       null,
  // nationality:         null,
  // passenger_type:      null

  const result = data.data

  return result;
};
